import { features } from "./features";

features.showInformeControlInforme = true;

export const environment = {
  production: true,
  v: '1',
  serverUrl: 'https://decorgandia.qualitapp.com/ws/',
  urlUpload: 'https://decorgandia.qualitapp.com/ws/upload',
  logoUrl: 'assets/img/logo_decorgandia.png',
  appName: 'decorgandia',
  schema: "decorgandiadb",
  features: features,
  version: "1.0.0",
  showTablasMaestras: {
    show: true,
    // 'variedades', 'productos_camion', 'paises', 'empresas', 'almacenes', 'prod_post_cosecha', 'calibre', 'materia_activa', 'tipo_de_residuos', 'ubicacion'
    modules: ['variedades', 'productos_camion', 'paises', 'empresas', 'almacenes', 'prod_post_cosecha', 'calibre', 'materia_activa', 'tipo_de_residuos', 'ubicacion']
  },
  urlN8N: 'https://www.gpt.sgdocs.com/',
  usePrefixedSidenav: false
};
